import { render, staticRenderFns } from "./GymSectorAdminMenu.vue?vue&type=template&id=6d77da6a"
import script from "./GymSectorAdminMenu.vue?vue&type=script&lang=js"
export * from "./GymSectorAdminMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports